<template>
  <div class="car-container">
    <section class="car-wrap">
      <div class="h3">
        共
        <span class="red">{{ results.length }}</span>注，
        <span class="red">{{ money * results.length }}</span>元
      </div>
      <div class="car-con">
        <div class="con empty" @click="clear">
          <i class="icons icon-empty"></i>清空
        </div>
        <div class="con money">
          <span>各注</span>
          <!--          <input type="number" v-model="money" placeholder="输入金额" precision="0"/>-->
          <input class="money-container" v-model="money" placeholder="输入金额" :min="0" :controls="false" :precision="0"/>
          <span>元</span>
        </div>
        <div class="con btn">
          <button style="font-size:14px;" @click="readyBat" class="btn-active">直接投注</button>
          <button
            style="font-size:14px;margin-left: 3px;"
            @click="openLongQueue"
            class="btn-changlong"
            v-if="islhLm"
          >长龙统计
          </button>
        </div>
      </div>
      <div v-show="isLongQueue" class="longQueue-dilog">
        <p>两面连开长龙</p>
        <li v-for="(item, index) in lotteryLongQueueData" :key="'ii'+index">
          <span class="longQueue-left">{{ `${item.class1} ${item.class3}` }}</span>
          <span class="longQueue-right">{{ `${item.period}期` }}</span>
        </li>
      </div>
    </section>

    <div class="dilog" v-show="isShow">
      <div class="content">
        <div class="title">投注确认</div>
        <div style="margin-bottom:5px" v-if="hasClass4">
          <span class="label">已选号码:</span>
          <span>{{ numbers }}；组合如下：</span>
        </div>
        <div class="table">
          <li style=" font-weight: bold;">
            <span>序号</span>
            <span>内容</span>
            <span>赔率</span>
            <span>金额</span>
          </li>
          <li v-for="(item, index) in results" :key="'ii'+index">
            <span>{{ index + 1 }}</span>
            <span>{{ item.content }}</span>
            <span>{{ item.odds }}</span>
            <span>{{ money }}</span>
          </li>
        </div>
        <div class="footer">
          <button @click="isShow=false">取消</button>
          <button @click="sendBat(money)" style="color:#40AFFE">确定</button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import Vue from "../../../../../utils/bus"
import objectPath from 'object-path';
import { InputNumber } from 'element-ui';
import { buZhongMaxSelect, LIAN_XIAO_MAX, lhCurrentTabLength } from "../../../../../utils/lhMethods";

export default {
  name: "car-wrap",
  components: {
    elInputNumber: InputNumber
  },
  props: {
    results: {
      type: Array,
      default() {
        return [];
      }
    },
    selectData: Array, // 未做处理的赔率数组
    islhLm: Boolean // 是否是六合玩法
  },
  data() {
    return {
      money: "",
      isShow: false,
      isLongQueue: false
    };
  },
  created() {
    Vue.$on("removeMoney", () => {
      this.money = '';
    })
  },
  computed: {
    ...mapState({
      lotteryLongQueueData: state => state.root.lotteryLongQueueData,
      selectedShengxiaoPlayRadio: state => state.root.selectedShengxiaoPlayRadio
    }),
    numbers() {
      if (this.results.length > 0)
        return this.results[0].class3 || '';
      else return '';
    },
    hasClass4() {
      if (this.results.length > 0 && this.results[0].class4 == undefined) {
        return false;
      } else {
        return true
      }
      ;
    }
  },
  methods: {
    sendBat(money) {
      this.$emit("sendBat", money);
      this.isShow = false;
    },
    // 打开长龙弹框
    openLongQueue() {
      this.isLongQueue = !this.isLongQueue;
    },
    clear() {
      this.money = "";
      this.$emit("clear");
    },
    readyBat() {
      const resultsLength = this.results.length;
      const selectDataLength = this.selectData.length;
      let errorMsg = '';
      if (resultsLength === 0 && selectDataLength === 0) {
        errorMsg = "至少选择一项进行投注";
      }
      if (this.money == 0 || this.money == "") {
        errorMsg = "输入投注金额";
      }
      // 六合部分的判断
      if (this.islhLm) {
        const key = objectPath.get(this.selectData, '0.played_name');
        let ordersLength = lhCurrentTabLength(key);
        if (selectDataLength < ordersLength) {
          errorMsg = `请最少选择${ordersLength}个号码`;
        }
        const firstItemClass = objectPath.get(this.selectData, `0.class1`);
        const firstOrderClass2 = objectPath.get(this.selectData, `0.class2`);
        if (firstItemClass === '连尾' && selectDataLength > 8) {
          errorMsg = `最多选择8个号码`;
        }
        if (firstItemClass === '连肖' && selectDataLength > LIAN_XIAO_MAX) {
          errorMsg = `最多选择${LIAN_XIAO_MAX}个号码`;
        }
        if (firstItemClass === '自选不中') {
          const maxSelect = buZhongMaxSelect(key || firstOrderClass2);
          if (maxSelect && selectDataLength > maxSelect) {
            errorMsg = `最多选择${maxSelect}个号码`;
          }
        }
        if (
          (firstItemClass === '中一' || firstItemClass === '特平中') && selectDataLength > 20
        ) {
          errorMsg = `最多选择20个号码`;
        }
        // 连码最多10个号码
        if (
          ((firstOrderClass2 === '三全中' || firstOrderClass2 === '三中二' || firstOrderClass2 === '三中二X') && (this.selectedShengxiaoPlayRadio == 1 || this.selectedShengxiaoPlayRadio == 2) && selectDataLength > 10)
        ) {
          errorMsg = `最多选择10个号码`;
        }
        // 连码其他的玩法，生肖对碰、尾数对碰丶混合对碰
        if (selectDataLength > 2 && (this.selectedShengxiaoPlayRadio == 3 || this.selectedShengxiaoPlayRadio == 4 || this.selectedShengxiaoPlayRadio == 5)) {
          errorMsg = `最多选择2个号码`;
        }
      }
      if (errorMsg) {
        this.$toast.center(errorMsg);
        return;
      }
      this.isShow = true;
    }
  }
};
</script>

<style scoped lang="less">
.dilog {
  position: absolute;
  top: 0;
  left: 0;
  height: 100%;
  width: 100%;
  background-color: rgba(0, 0, 0, 0.4);
  z-index: 1000;

  .content {
    margin: 27vw 5vw;
    width: 90%;
    min-height: 93vw;
    border-radius: 3vw;
    background-color: #fff;
    position: fixed;

    .title {
      height: 80px;
      width: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
      background-color: #8dce16;
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      border-top-left-radius: 20px;
      border-top-right-radius: 20px;
    }

    .table {
      overflow-y: scroll;
      height: 500px;
      padding: 0 10px;

      li {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        padding: 10px;
        font-size: 12px;
      }
    }

    .footer {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 80px;
      display: flex;
      flex-direction: row;
      justify-content: center;
      align-items: center;

      button {
        width: 180px;
        height: 50px;
        margin: 20px;
        border-radius: 10px;
      }
    }
  }
}

.car-wrap {
  width: 100vw;
  position: fixed;
  bottom: 0;
  display: flex;
  font-size: 26px;
  background: #fffbec;
  flex-direction: column;

  .h3 {
    display: flex;
    border-top: 1px solid #dfdddd;
    align-items: center;
    justify-content: center;
    height: 50px;
  }

  .car-con {
    color: #ac8b25;
    height: 105px;
    display: flex;
    background: linear-gradient(to top, #fff5d2, #fffbec);
    border-top: 1px solid #e7d698;
    align-items: center;
    justify-content: center;

    .con {
      height: 100%;
      display: flex;
      padding: 0 20px;
      align-items: center;
      justify-content: center;
    }

    .con ~ .con {
      border-left: 1px solid #e7d698;
    }

    .empty {
      width: 140px;
      padding-left: 30px;
    }

    .money-container,
    .money {
      input {
        width: 140px;
        height: 60px;
        border: 1px solid #d0d0d0;
        margin: 0 10px;
        text-align: center;
      }
    }

    .money-container {
      width: 155px !important;
    }

    .btn {
      flex: 1;

      button {
        width: 176px;
        color: #fff;
        height: 64px;
        display: inline-block;
        font-size: 28px;
        text-align: center;
      }
    }
  }
}

.longQueue-dilog {
  position: absolute;
  bottom: 161px;
  right: 2px;
  min-width: 250px;
  border: 1px solid #e7d698;
  background: linear-gradient(to top, #fff5d2, #fffbec);

  p {
    padding: 20px 10px;
    text-align: center;
    border-bottom: 1px solid #e7d698;
    color: #000000;
  }

  li {
    padding: 10px 5px;
    list-style: none;
    border-bottom: 1px solid #e7d698;
    color: #999;
    background-color: #fff;

    span {
      display: inline-block;
    }

    .longQueue-left {
      width: 60%;
      color: #080035;
    }

    .longQueue-right {
      width: 30%;
      text-align: right;
      color: red;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/home/hall/components/car-wrap/index.vue